export default {
  MuiToolbar: {
    regular: {
      // If height changes also update menuScrollListenerProvider.js
      minHeight: '40px',
      height: '40px',
    },
    gutters: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
};
